import gql from 'graphql-tag'

const openDBSession = gql`
  mutation openDBSession($db_id: Float!, $workspace_id: Float!) {
    openDBSession(db_id: $db_id, workspace_id: $workspace_id) {
      status
      msg
      data
    }
  }
`

export default openDBSession
